<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading" class="edit-actions">
    <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>
    <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
        <mat-icon>clear</mat-icon>
        </button>
    <button *ngIf="!loadingAction" matTooltip="Guardar" (click)="save()" mat-icon-button class="card-inline">
          <mat-icon>done</mat-icon>
        </button>
    <button *ngIf="!loadingAction" matTooltip="Enviar" (click)="send()" mat-icon-button class="card-inline">
                <mat-icon>flag</mat-icon>
              </button>
</div>
<mat-tab-group (selectedIndexChange)="selectedIndexChange($event)" #tabGroup>
    <mat-tab label="Lote">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-send-order-logistics-detail [hidden]="loading" #sendOrderLogisticsDetail></app-send-order-logistics-detail>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Ordenes">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-send-order-logistics-item [hidden]="loading" #sendOrderLogisticsItem></app-send-order-logistics-item>
                </div>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>